<script>
  import { mapState } from 'pinia'
  import {useAppStore} from "@/store/modules/app";
  import ProgressSpinner from 'primevue/progressspinner';

  export default {
    components: {
      ProgressSpinner
    },
    computed: {
      ...mapState(useAppStore, ['isLoading'])
    }
  }
</script>
<template>
  <div class="spinner" v-if="isLoading">
    <ProgressSpinner style="width: 70px; height: 70px" />
  </div>
</template>
<style>
  .spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    z-index: 190;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, .8);
  }
</style>